import React from "react";
import ReactECharts from "echarts-for-react";
import ChartEmptyState from "./ChartEmptyState";

export default class PieChartTemplate3 extends React.Component {
  constructor(props) {
    super(props);
  }

  getOption = (graphData, reportNameFinal, pieColors) => {
    let opt = {
      //color: graphData ? this.getRandomColorList(graphData) : [],
      tooltip: {
        trigger: "item",
      },
      legend: {
        orient: "horizontal",
        top: 15,
      },
      series: [
        {
          name: reportNameFinal,
          type: "pie",
          radius: "50%",
          data: graphData ? graphData : [],
          animation: true,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],
    };
    if(pieColors){
      opt['color'] = pieColors.split(',')
    }
    return opt;
  };

  getTotalData = (graphData) => {
    let total = 0;
    graphData &&
      graphData.map((item, index) => {
        total = total + Number(item.yProperties);
      });
    return total;
  };

  getData = (subTitle, data) => {
    let f = subTitle.split("[");
    f = f[1] && f[1].split("]");
    data.map((d) => {
      if (d.name == f[0]) {
        subTitle = subTitle.split("{{");
        const tmp = subTitle[1].split("}}");
        subTitle = subTitle[0] + ` ${d.value} ` + tmp[1];
      }
    });
    return subTitle;
  };

  render() {
    const { graphData, reportNameFinal, pieConfig, graphHeight } = this.props;

    let data = [];
    graphData &&
      graphData.map((item, index) => {
        const newItem = {
          name: item.xProperties,
          value: item.yProperties,
        };
        data.push(newItem);
      });
    
    const pieColors = pieConfig && pieConfig.pieColors;

    let title = pieConfig && pieConfig.title;
    let subTitle = pieConfig && pieConfig.subTitle;
    let isNoData = !graphData || graphData.every((el) => el.yProperties === 0);

    if (title && title.indexOf("{{total}}") != -1) {
      let total = this.getTotalData(graphData);
      if (title && title.indexOf("(,)") != -1){
        total = total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        title = title.replace("(,)", '');
      }
      title = title.replace("{{total}}", total);
    }
    if (subTitle && subTitle.indexOf("{{total}}") != -1) {
      let total = this.getTotalData(graphData);
      if (subTitle.indexOf("(,)") != -1){
        total = total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        subTitle = subTitle.replace("(,)", '');
      }
      subTitle = subTitle.replace("{{total}}", total);
    }

    if (title && title.indexOf("{{data") != -1) {
      title = this.getData(title, data);
    }

    if (subTitle && subTitle.indexOf("{{data") != -1) {
      subTitle = this.getData(subTitle, data);
      if (subTitle.indexOf("(,)") != -1){
        subTitle = subTitle.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        subTitle = subTitle.replace("(,)", '');
      }
    }

    return (
      <div
        style={{ width: "100%", cursor: "pointer" }}
        className={`reportMainContainer chart-report chart-report--pie${isNoData ? " chart-report--empty" : ""}`}
      >
        {isNoData ? (
          <ChartEmptyState graphHeight={graphHeight} variant="pie" />
        ) : (
          <>
            <ReactECharts
              option={this.getOption(data, reportNameFinal || "", pieColors)}
              style={{ height: graphHeight, width: "100%" }}
            />

            <div className="pie-total-data-txt" style={{ marginTop: "-39px" }}>
              {pieConfig && pieConfig.title && (
                <p
                  className="d-flex justify-content-center"
                  style={{ fontWeight: 800, margin: 0, fontSize: 14 }}
                >
                  {title}
                </p>
              )}
              {pieConfig && pieConfig.subTitle && (
                <p
                  className="d-flex justify-content-center"
                  style={{ fontWeight: 400, fontSize: 12, margin: 0 }}
                >
                  {subTitle}
                </p>
              )}
            </div>
          </>
        )}
      </div>
    );
  }
}
